export default __webpack_public_path__ + "static/media/shoePlaceholder2.d62350fa.svg";